import type { ReactElement } from 'react'
import { ScreenBreakpoints } from '../config/ScreenBreakpoints'
import { useWindowSize } from '../hooks/useWindowSize'

const containerClass = 'flex flex-1 justify-end space-x-px-24 lg:space-x-px-48'
const buttonWrapperClass = 'flex items-end'
// const pageViewCountClass = 'text-px-13 leading-px-18 font-semibold text-white/50 flex'
export const ProjectViewCounterAndButton: React.FunctionComponent<
  React.PropsWithChildren<{
    ctaButton: ReactElement
  }>
> = ({ ctaButton }) => {
  const { breakpointMd } = ScreenBreakpoints

  const { width } = useWindowSize()
  return (
    <>
      {!!width && width < breakpointMd ? (
        <>
          {/* TODO: Use when determined where the data is coming from */}
          {/* <div className="flex flex-1 flex-row md:justify-end items-center space-x-[8px]">
            {views && (
              <>
                <Eye className="w-[25px] h-[12px]" />
                <div className={pageViewCountClass}>{views + ' Aufrufe'}</div>
              </>
            )}
          </div> */}
          <div className={containerClass}>
            <div className={buttonWrapperClass}>{ctaButton}</div>
          </div>
        </>
      ) : (
        <>
          <div className={containerClass}>
            {/* <div className="flex flex-1 flex-row md:justify-end items-center space-x-[8px]">
              {views && (
                <>
                  <Eye className="w-[25px] h-[12px]" />
                  <div className={pageViewCountClass}>{views + ' Aufrufe'}</div>
                </>
              )}
            </div> */}
            <div className={buttonWrapperClass}>{ctaButton}</div>
          </div>
        </>
      )}
    </>
  )
}
